export class User {
    MaNV: string;
    TenNV: string;
    TenDangNhap: string;
    MatKhau: string;
    MaCH: string;
}

export class User_CP {
  oldPass: string = '';
  newPass: string = '';
  newPass_confirm: string = '';
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts